import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import getExternalServicesToken from '../../services/API/externalServicesToken';
import { get } from 'lodash';
import { Link } from 'redux-little-router';
import { routeMap } from '../../../../router';
import Loading from '../../../../components/Loading';
import ErrorMessage from '../../../Taps/components/ErrorMessage';

export default class RedirectToExternalServices extends Component {
  static propTypes = {
    query: PropTypes.string,
  };

  state = {
    loading: true,
  };

  async componentDidMount() {
    await this.fetchTaxResidentToken();
  }

  async fetchTaxResidentToken() {
    const tokenResponse = await getExternalServicesToken(this.props.query);
    const lk3Token = get(tokenResponse, 'data.lk3Token');
    if (tokenResponse.isOk && lk3Token) {
      return (location.href = lk3Token);
    } else {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <div className="header-wrapper header-wrapper__main">
          <div className="header header__main content">
            <a className="header-title">
              <span className="header-title_icon" />
              <span className="header-title_text">
                Личный кабинет
                <br /> налогоплательщика
              </span>
            </a>
            <div className="header_right">
              <div className="header_links">
                <span
                  className="white"
                  style={{ padding: '0 20px 5px', display: 'inline-block', float: 'right' }}
                >
                  Контакт-центр
                </span>
                <a href="tel:8-800-222-2222" className="phone">
                  8-800-222-2222
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="main-page_center">
          <div className="main-page_cell">
            <div className="content">
              <div className="main-page_row main-page_row__small">
                {this.state.loading ? (
                  <Loading isLight={true} />
                ) : (
                  <div className="white-block main-page_form">
                    <ErrorMessage />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-wrapper">
          <div className="footer footer__main content">
            <div className="footer_left">
              <span className="mobile-hide">
                При наличии вопросов по работе сервиса Вы можете воспользоваться режимом&nbsp;
              </span>
              <Link href={routeMap.faq} className="link white link__underline">
                «Вопрос-ответ»
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
